var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selectbox",on:{"click":_vm.select}},[_c('div',{staticClass:"text"},[_vm._v("筛选")]),_c('div',{staticClass:"selectbox-text"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"weui-cell__ft"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}]},[_vm._v("请选择")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }